import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    useEffect(() => {
        yotpoWidgetsContainer.initWidgets();
        setTimeout(() => {
            yotpo.refreshWidgets();
        }, 300);
    }, [products])

    return (
        // style={loading ? "opacity: 0.3;" : ""}
        <ul class="ns-d-flex ns-flex-wrap productGrid ns-products-list">
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} index={index} />
            })}
        </ul>
    )
}
